<template>
  <div
    class="program-history-section"
  >
    <div
      id="history"
      class="history-section"
    >
      <div class="mobile">
        <div class="container">
          <div class="row">
            <div class="col-12">
              <img
                class="full-img"
                loading="lazy"
                :src="section.mobile_img.url"
                :alt="section.mobile_img.alt"
                :style="{ objectPosition: `${imgXPos}% ${imgYPos}%` }"
              >
            </div>
          </div>
        </div>
      </div>

      <div class="desktop">
        <div class="container">
          <div class="row">
            <div class="col-12 stats">
              <div class="col-12">
                <img
                  class="full-img"
                  loading="lazy"
                  :src="section.img.url"
                  :alt="section.img.alt"
                  :style="{ objectPosition: `${imgXPos}% ${imgYPos}%` }"
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import stripBlockTags from '@/utils/strip-block-tags';

export default {
  name: 'BannerLikeSection',

  props: {
    section: { type: Object, required: true }
  },

  methods: {
    stripBlockTags,

    imgXPos() {
      if (this.screenWidth >= 1170) {
        return this.section.img_x_pos;
      }
      return this.section.mob_img_x_pos;
    },

    imgYPos() {
      if (this.screenWidth >= 1170) {
        return this.section.img_y_pos;
      }
      return this.section.mob_img_y_pos;
    }
  }
};
</script>

<style lang="scss" scoped>
.history-section {
  margin-bottom: 36px;

  h2::v-deep {
    font-size: 48px;
    line-height: 48px;
    font-weight: 700;
    text-transform: uppercase;

    @media screen and (min-width: $breakpoint-lg) {
      font-size: 80px;
      line-height: 80px;
    }

    strong {
      color: $thd-orange;
    }
  }

  hr {
    width: 60px;
    color: $thd-tan;
    margin: 0;
  }

  .sub-text {
    font-size: 18px;
    line-height: 24px;
  }

  .full-img {
    width: 100%;
  }

  .years {
    text-align: center;
    flex-shrink: 0;

    .number-holder {
      display: flex;
      justify-content: space-between;
      gap: 20px;
      margin-top: 24px;
    }

    .year {
      font-size: 15em;
      line-height: unset;
      font-weight: 700;
      background: $thd-black;
      color: $thd-white;
      display: inline-block;
      margin: 0;
      padding: 18px;
      width: 50%;
    }

    p {
      color: $thd-cool-gray;
      font-weight: 400;
      text-transform: uppercase;
      letter-spacing: 0.2em;
      font-size: 12px;
      line-height: 12px;
      margin: 8px 0 0;
    }

    img {
      width: 100%;
      margin-top: 24px;
    }
  }

  .stats {
    margin-top: 40px;

    .col-12 {
      display: flex;
      justify-content: stretch;
      margin-bottom: 20px;

      .text {
        color: $thd-cool-gray;
        font-weight: 400;
        text-transform: uppercase;
        letter-spacing: 0.2em;
        font-size: 12px;
        line-height: 12px;
        display: flex;
        align-items: flex-end;
        text-align: right;
      }

      .line {
        border-bottom: 1px solid $thd-tan;
        flex-grow: 1;
        margin: 0 12px;
      }

      .number {
        font-size: 28px;
        line-height: 32px;
        font-weight: 700;
        font-stretch: condensed;
      }
    }
  }

  .desktop {
    .sub-text {
      line-height: 28px;
    }

    .full-img {
      width: 100%;
    }

    .years {
      margin-top: 40px;

      .number-holder {
        display: flex;
        justify-content: flex-end;
        gap: 20px;
      }

      .year {
        font-size: 162px;
        line-height: 162px;
        padding: 82px;
      }

      p {
        font-size: 14px;
        line-height: 16px;
      }

      img {
        width: 100%;
        margin-top: 0;
      }
    }

    .stats {
      .col-12 {
        margin-bottom: 40px;

        .text {
          font-size: 14px;
          line-height: 16px;
        }
      }
    }
  }
}
</style>
